import { NavLink, Outlet, useLocation } from "react-router-dom";

/**
 * App shell (B4): header + nav + routed outlet. plain CSS, Korean labels.
 * /flow (통합 워크데스크)는 사이드바 레이아웃이라 본문 폭 제한을 해제한다.
 */
export function App(): JSX.Element {
  const { pathname } = useLocation();
  const fullBleed = pathname.startsWith("/flow") || pathname.startsWith("/distributor");
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    isActive ? "active" : undefined;
  return (
    <div className="app">
      <header className="app-header">
        <span className="brand">수출실무 데스크</span>
        {/* 코어 = 두 개의 데스크. 딜·새딜은 워크데스크 내부 동선으로 흡수, 홈·게이트데모는 네비에서 제거(라우트 존치). */}
        <nav>
          <NavLink to="/flow" className={linkClass}>
            워크데스크
          </NavLink>
          <NavLink to="/distributor" className={linkClass}>
            총판 데스크
          </NavLink>
        </nav>
        <span className="nav-spacer" />
        {/* 유틸리티 (우측 정렬) */}
        <nav className="nav-util">
          <NavLink to="/master" className={linkClass}>
            마스터데이터
          </NavLink>
          <NavLink to="/upload" className={linkClass}>
            엑셀 검증
          </NavLink>
        </nav>
      </header>
      <main className={fullBleed ? "app-main app-main--full" : "app-main"}>
        <Outlet />
      </main>
    </div>
  );
}
